import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../Button';
import { NumberInput } from '../../../NumberInput/NumberInput';
import './MinutesInput.scss';

export interface MinutesInputProps {
  minutes: number;
  max?: number;
  minutesChanged: (minutes: number, error?: string) => void;
  arrivedNow?: () => void;
}

export const MinutesInput: FC<MinutesInputProps> = props => {
  const { minutes, max, minutesChanged, arrivedNow } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-2">
        {arrivedNow && (
          <Button
            size="small"
            appearance="outline"
            className="minutesInputShortcut"
            onClick={() => arrivedNow()}
          >
            {t('classbook:absences:arrived_now', { defaultValue: 'Ankunft jetzt' })}
          </Button>
        )}
        <Button
          size="small"
          appearance="outline"
          className="minutesInputShortcut"
          onClick={() => minutesChanged?.(5)}
        >
          {t('classbook:absences:missed_5_minutes', { defaultValue: '5 Minuten' })}
        </Button>
        <Button
          size="small"
          appearance="outline"
          className="minutesInputShortcut"
          onClick={() => minutesChanged?.(10)}
        >
          {t('classbook:absences:missed_10_minutes', { defaultValue: '10 Minuten' })}
        </Button>
        <Button
          size="small"
          appearance="outline"
          className="minutesInputShortcut"
          onClick={() => minutesChanged?.(15)}
        >
          {t('classbook:absences:missed_15_minutes', { defaultValue: '15 Minuten' })}
        </Button>
      </div>

      <NumberInput
        appearance="filled-darker"
        min={1}
        value={minutes}
        max={max}
        label={t('classbook:absences:minutes', { defaultValue: 'Minuten' })}
        onInput={minutesChanged}
      />
    </div>
  );
};
